module.exports = __webpack_public_path__ + "img/trenchers_tillers.ec224aef.jpg";